import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PagedResult } from '../../Models/PagedResult';
import { PagingModel } from '../../Models/PagingModel';
import { PagingService } from '../../Services/PagingService';
import { NbDialogService } from '@nebular/theme/components/dialog/dialog.service';
import { IFilter } from '../../Models/queryModel';
import * as momentHijri from 'moment-hijri';

export class BaseComponent implements OnInit {
  token: string;
  isAuthorized = false;
  pagingModel: PagingModel;
  finishLoading = false;
  constructor(
    public route: Router,
    public service: any,
    public pagingService: PagingService = null,
    moduleName: string = '',
    public dialog: NbDialogService = null
  ) {
    this.pagingModel = new PagingModel();
    this.token = sessionStorage.getItem('serviceAdmintoken');

    if (this.token == null) {
      this.route.navigate(['/login']);
    } else this.isAuthorized = true;
  }

  ngOnInit() {}

  loadEntities() {
    if (this.isAuthorized)
      this.service.get(this.pagingModel.query).subscribe((res) => {
        this.initiResponse(res);
        this.finishLoading = true;
      });
  }

  // Promise<> loadEntitiesPromise() {
  //   await this.service.get(this.pagingModel.query).subscribe((res) => {
  //     this.finishLoading = true;
  //    return this.initiResponse(res);
  //   });
  // }

  loadEntitiesWithFilter(filter: string) {
    this.pagingModel.query.searchTerm = filter;
    this.service.get(this.pagingModel.query).subscribe((res) => {
      this.initiResponse(res);
      this.finishLoading = true;
    });
  }

  authorize(permission: string) {
    if (this.token != null) return true;
    else return false;
  }

  authenticate() {
    if (this.token == null) {
      this.route.navigate(['/login']);
    }
  }

  initiResponse(result: PagedResult) {
    this.pagingModel.responseObj = result.result;
    this.pagingModel.responseData = result;
    this.pagingModel.pager = Array.from({ length: result.totalPages }, (v, k) => k + 1);
    this.pagingModel.totalPages = result.totalPages;
    return this.pagingModel;
  }

  getHijriDate(date) {
    return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
  }

  setPage(page: number) {
    this.finishLoading = false;
    this.pagingService.setPage(page, this.pagingModel, this.service);
    this.finishLoading = true;
  }
}
